import React, { lazy, Suspense, useEffect, useState } from 'react';

import { HeadObject } from 'services/generic';
import { GetArticlesBySection, getSearch } from 'services/helpcentre';

import { useBrowsing } from 'hooks/use-browsing';
import { ReplaceCrumb, useSetBreadcrumbs } from 'hooks/use-set-breadcrumbs';

import { safeDecode } from 'helpers/url/safe-decode';

import { metaData } from '@help-centre/constants';

import styles from '../index.module.scss';

const CategoryList = lazy(
	() => import('core/generic/components/lists/category-list')
);
const Breadcrumbs = lazy(
	() => import('core/generic/components/navigation/breadcrumbs')
);
const Seo = lazy(() => import('core/mancity/components/general/seo'));

export default function SearchTerm() {
	const { asPath, query } = useBrowsing();
	const { generateSpecificBreadcrumbs } = useSetBreadcrumbs();
	const [searchResults, setSearchResults] =
		useState<GetArticlesBySection | null>(null);

	const term = typeof query['term'] === 'string' ? query['term'] : '';
	const updatedMetaData = {
		...metaData,
		title: `${metaData.title}${term}`,
	} as HeadObject;

	const breadcrubmsReplace: Map<string, ReplaceCrumb> = new Map([
		['/search-results', { isHidden: true }],
		[`${asPath.split('?')[0]}`, { title: safeDecode(term) }],
	]);
	const specificBreadcrumbs = generateSpecificBreadcrumbs({
		baseName: 'Help & Support',
		replace: breadcrubmsReplace,
	});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const getSearchResults = await getSearch(term).then(
					(response) => response?.data
				);
				setSearchResults(getSearchResults);
			} catch (e) {
				console.error(e);
			}
		};

		fetchData();
	}, [term]);

	return (
		<Suspense fallback={null}>
			<>
				<Seo head={updatedMetaData} />
				<div>
					<div className="row">
						<div className="col-12">
							<div className={styles.breadcrumbs}>
								{term && (
									<Breadcrumbs
										listCrumbs={specificBreadcrumbs}
									/>
								)}
							</div>
							<div className={styles.searchWrapper}>
								{searchResults &&
								Array.isArray(searchResults) &&
								searchResults.length > 0 ? (
									<CategoryList
										title={''}
										list={searchResults.map((article) => ({
											title: article.name,
											url: article.url,
											target: '_self',
										}))}
									/>
								) : (
									term && (
										<>
											<div>
												Sorry, we couldn&apos;t find any
												results for &apos;
												<span className="body-medium bold">
													{safeDecode(
														(query[
															'term'
														] as string) || ''
													)}
												</span>
												&apos;.
											</div>
											<div>
												Try a new search term or browse
												our help topics instead.
											</div>
										</>
									)
								)}
							</div>
						</div>
					</div>
				</div>
			</>
		</Suspense>
	);
}
